import { buildChecklistSalesEmailHeadStyles } from './checklistSalesEmailFonts';
import { getStaticChecklistSalesEmailHeadingImages } from './checklistSalesEmailHeadingImages';
import { buildChecklistSalesEmailHtmlContent } from './checklistSalesEmailTemplate';

const SITE_BASE = (process.env.REACT_APP_BASE_URL || 'https://antologia.tech').replace(/\/$/, '');

export function absolutizeEmailAssetUrls(html, baseUrl = SITE_BASE) {
  return html
    .replace(/src="\/images\//g, `src="${baseUrl}/images/`)
    .replace(/href="\/\?/g, `href="${baseUrl}/?`);
}

/**
 * HTML-письмо sales-чек-листа с inline-стилями для почтовых клиентов.
 */
export function renderChecklistSalesEmailHtml(data, { baseUrl = SITE_BASE, headingImages } = {}) {
  const normalizedBase = baseUrl.replace(/\/$/, '');
  const mergedHeadingImages = {
    ...getStaticChecklistSalesEmailHeadingImages(),
    ...headingImages,
  };
  const content = buildChecklistSalesEmailHtmlContent(data, normalizedBase, mergedHeadingImages);
  const headStyles = buildChecklistSalesEmailHeadStyles(normalizedBase);
  return `<!DOCTYPE html>
<html lang="ru">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <title>Результаты чек-листа sales</title>
  ${headStyles}
</head>
<body style="margin:0;padding:0;background-color:#f3f4f6;font-family:'Inter Display',Arial,Helvetica,sans-serif;">
${content}
</body>
</html>`;
}
